// Experimental features the user can switch on from their profile. Stored in this browser only
// (localStorage), so nothing new is written to the shared Firebase data.
const KEY = 'stew_experiments';
const EVENT = 'stew-experiments';

// Nothing is experimental right now. Add { id, label, description } here to get a switch in the profile.
export const EXPERIMENTS = [];

export const getExperiments = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY)) || {};
  } catch (e) {
    return {};
  }
};

export const setExperiment = (id, enabled) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ ...getExperiments(), [id]: !!enabled }));
  } catch (e) { /* storage blocked: the choice lasts until reload */ }
  window.dispatchEvent(new Event(EVENT));
};

// Calls `callback` with the current settings whenever they change (this tab or another).
export const subscribeExperiments = (callback) => {
  const onChange = () => callback(getExperiments());
  window.addEventListener(EVENT, onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener('storage', onChange);
  };
};
